import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import moment from "moment";

@Component({
  selector: 'app-date-range-picker-popover-v2',
  templateUrl: './date-range-picker-popover-v2.component.pug',
  styleUrls: ['./date-range-picker-popover-v2.component.scss'],
  standalone: false
})
export class DateRangePickerPopoverV2Component implements OnInit, OnChanges {
  @Input() start!: any;
  @Input() end!: any;
  @Input() fromDateLabel = '';
  @Input() toDateLabel = '';
  @Output() dateChange = new EventEmitter<{ start: moment.Moment, end: moment.Moment }>();
  @Output() calendarVisibilityChange = new EventEmitter<{ showStart: boolean; showEnd: boolean }>();

  filterByLabel = '';
  startDate: Date = new Date();
  endDate: Date = new Date();
  today: Date = new Date();
  @Input() enableCustom = false;
  config = {showWeekNumbers: false};

  showStartCalendar = false;
  showEndCalendar = false;

  startStr = '';
  endStr = '';


  setLabel() {
    this.startStr = this.start.format('DD MMM, YYYY');
    this.endStr = this.end.format('DD MMM, YYYY');
  }

  ngOnInit(): void {
    this.config['dateInputFormat'] = moment.localeData().longDateFormat('L');
    this.setLabel();
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  startDateChange(event) {
    const startDate = moment(event)
    this.start = startDate;
    if (this.start > this.end) {
      this.end = startDate;
    }
    this.dateChange.emit({start: this.start, end: this.end});
    this.showStartCalendar = false;
    this.setLabel();
  }

  endDateChange(event: Date) {
    const endDate = moment(event).endOf('day')
    this.end = endDate;
    if (this.start > this.end) {
      this.start = endDate
    }
    this.dateChange.emit({start: this.start, end: this.end});
    this.showEndCalendar = false;
    this.setLabel();
  }

  onStartCalendarShown() {
    this.showStartCalendar = true;
    this.emitCalendarVisibility();
  }

  onStartCalendarHidden() {
    this.showStartCalendar = false;
    this.emitCalendarVisibility();
  }

  onEndCalendarShown() {
    this.showEndCalendar = true;
    this.emitCalendarVisibility();
  }

  onEndCalendarHidden() {
    this.showEndCalendar = false;
    this.emitCalendarVisibility();
  }

  emitCalendarVisibility() {
    this.calendarVisibilityChange.emit({
      showStart: this.showStartCalendar,
      showEnd: this.showEndCalendar
    });
  }
}
